import { config } from 'env';

import type { AnalyticsClient } from './types';
import { posthogClient } from './posthog-client';
import { noopAnalyticsClient } from './noop-client';

// ==============================|| ANALYTICS — ACTIVE CLIENT ||============================== //
// The single decision point for "is analytics on?", shared by the React provider
// and the domain functions so both talk to the exact same singleton.

// Empty / whitespace-only key => analytics disabled (safe no-op in dev and tests).
export const isAnalyticsEnabled = Boolean(config.posthog_key && config.posthog_key.trim());

export const activeAnalyticsClient: AnalyticsClient = isAnalyticsEnabled ? posthogClient : noopAnalyticsClient;
